<template>
    <risk-area-main></risk-area-main>
</template>
<script>
    import RiskAreaMain from "../components/risk-area/RiskAreaMain";
    import {createNamespacedHelpers} from 'vuex';

    const {mapActions} = createNamespacedHelpers('riskIndex');

    export default {
        name:       'RiskAreaView',
        components: {
            RiskAreaMain
        },
        methods:    {
            ...mapActions([
                'loadRiskAreaData'
            ])
        },
        mounted() {
            this.loadRiskAreaData();
        }
    };
</script>
